import React, { useState } from "react"
import Lightbox from "yet-another-react-lightbox"
import "yet-another-react-lightbox/styles.css"
import { API } from "../../constants/constants"
import { WorkshopGalleryBigType } from "../../types/mainModulTypes"
import { Swiper, SwiperSlide } from "swiper/react"
import { Pagination } from "swiper/modules"
import "swiper/css"
import "swiper/css/pagination"

export default function WorkshopGalleryBig(props: WorkshopGalleryBigType) {
    const [index, setIndex] = useState(-1)

    const slides = [
        {
            src: API + props?.workshopGalleryBigLine1Image1.url,
            alt: props.workshopGalleryBigLine1Image1.description ?? props.workshopGalleryBigLine1Image1.name,
        },
        {
            src: API + props?.workshopGalleryBigLine1Image2.url,
            alt: props.workshopGalleryBigLine1Image2.description ?? props.workshopGalleryBigLine1Image2.name,
        },
        {
            src: API + props?.workshopGalleryBigLine1Image3.url,
            alt: props.workshopGalleryBigLine1Image3.description ?? props.workshopGalleryBigLine1Image3.name,
        },
        {
            src: API + props?.workshopGalleryBigLine2Image.url,
            alt: props.workshopGalleryBigLine2Image.description ?? props.workshopGalleryBigLine2Image.name,
        },
        {
            src: API + props?.workshopGalleryBigLine3Image1.url,
            alt: props.workshopGalleryBigLine3Image1.description ?? props.workshopGalleryBigLine3Image1.name,
        },
        {
            src: API + props?.workshopGalleryBigLine3Image2.url,
            alt: props.workshopGalleryBigLine3Image2.description ?? props.workshopGalleryBigLine3Image2.name,
        },
        {
            src: API + props?.workshopGalleryBigLine3Image3.url,
            alt: props.workshopGalleryBigLine3Image3.description ?? props.workshopGalleryBigLine3Image3.name,
        },
    ]

    return (
        <>
            <div className="px-4">
                <Swiper modules={[Pagination]} slidesPerView={1} pagination spaceBetween={10} className="mySwiper sm:!hidden ">
                    {slides.map((slide, index) => (
                        <SwiperSlide key={index}>
                            <img src={slide.src} alt={slide.alt} className="aspect-[4/3] w-full object-cover rounded-default" />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
            <div className="max-w-content-sm mx-auto hidden sm:grid grid-cols-3 gap-8">
                <img
                    src={API + props?.workshopGalleryBigLine1Image1.url}
                    alt={props.workshopGalleryBigLine1Image1.description ?? props.workshopGalleryBigLine1Image1.name}
                    className="col-span-1 row-span-1 w-full h-44 object-cover rounded-default cursor-pointer"
                    onClick={() => setIndex(0)}
                />
                <img
                    src={API + props?.workshopGalleryBigLine1Image2.url}
                    alt={props.workshopGalleryBigLine1Image2.description ?? props.workshopGalleryBigLine1Image2.name}
                    className="col-span-1 row-span-1 h-44 w-full object-cover rounded-default cursor-pointer"
                    onClick={() => setIndex(1)}
                />
                <img
                    src={API + props?.workshopGalleryBigLine1Image3.url}
                    alt={props.workshopGalleryBigLine1Image3.description ?? props.workshopGalleryBigLine1Image3.name}
                    className="col-span-1 row-span-1 h-44 w-full object-cover rounded-default cursor-pointer"
                    onClick={() => setIndex(2)}
                />
                <img
                    src={API + props?.workshopGalleryBigLine2Image.url}
                    alt={props.workshopGalleryBigLine2Image.description ?? props.workshopGalleryBigLine2Image.name}
                    className="col-span-3 row-span-2 h-[22rem] w-full object-cover rounded-default cursor-pointer"
                    onClick={() => setIndex(3)}
                />
                <img
                    src={API + props?.workshopGalleryBigLine3Image1.url}
                    alt={props.workshopGalleryBigLine3Image1.description ?? props.workshopGalleryBigLine3Image1.name}
                    className="col-span-2 row-span-2 h-[22rem] w-full object-cover rounded-default cursor-pointer"
                    onClick={() => setIndex(4)}
                />
                <div className="h-[22rem] col-span-1 row-span-2 flex flex-col gap-8">
                    <img
                        src={API + props?.workshopGalleryBigLine3Image2.url}
                        alt={props.workshopGalleryBigLine3Image2.description ?? props.workshopGalleryBigLine3Image2.name}
                        className="w-full h-40 object-cover rounded-default cursor-pointer"
                        onClick={() => setIndex(5)}
                    />
                    <img
                        src={API + props?.workshopGalleryBigLine3Image3.url}
                        alt={props.workshopGalleryBigLine3Image3.description ?? props.workshopGalleryBigLine3Image3.name}
                        className="w-full h-40 object-cover rounded-default cursor-pointer"
                        onClick={() => setIndex(6)}
                    />
                </div>
            </div>

            <Lightbox slides={slides} open={index >= 0} index={index} close={() => setIndex(-1)} />
        </>
    )
}
